import { render, staticRenderFns } from "./DenunciasProdutoresBunge.vue?vue&type=template&id=756993d4&lang=pug"
import script from "./DenunciasProdutoresBunge.vue?vue&type=script&lang=js"
export * from "./DenunciasProdutoresBunge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports